import React from "react";
import { IServicePartner } from "../../models/serviceManagement.model";
import Loading from "../AssetsComponent/loading";

interface ServicePartnerTableProps {
  servicePartners: IServicePartner[];
  loading: boolean;
  onRowClick: (partner: IServicePartner) => void;
}

const ServicePartnerTable: React.FC<ServicePartnerTableProps> = ({
  servicePartners,
  loading,
  onRowClick,
}) => {
  if (loading) {
    return <Loading />;
  }
  return (
    <div className="bg-white rounded-lg shadow-lg border border-slate-100 mt-4">
      <div className="bg-white px-4 py-3 border-b border-slate-200">
        <h2 className="text-base font-semibold text-gray-900 flex items-center">
          <svg
            className="w-4 h-4 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          Service Partners ({servicePartners.length})
        </h2>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[700px]">
          <thead>
            <tr className="bg-gray-50 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
              <th className="px-3 py-3 border-r border-gray-200">Name</th>
              <th className="px-3 py-3 border-r border-gray-200">Mobile</th>
              <th className="px-3 py-3 border-r border-gray-200">District</th>
              <th className="px-3 py-3 border-r border-gray-200">Taluka</th>
              <th className="px-3 py-3">Pincode</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {servicePartners.length ? (
              servicePartners.map((item: IServicePartner, index: number) => (
                <tr
                  key={item._id}
                  className={`hover:bg-gray-50 transition-colors duration-150 ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td
                    className="px-3 py-2 text-xs text-center cursor-pointer hover:text-blue-600"
                    onClick={() => onRowClick(item)}
                  >
                    {item.name}
                  </td>
                  <td className="px-3 py-2 text-xs text-center">
                    {item.mobileNumber}
                  </td>
                  <td className="px-3 py-2 text-xs text-center max-w-0.5">
                    {item.address.district}
                  </td>
                  <td className="px-3 py-2 text-xs text-center max-w-0.5">
                    {item.address.taluka}
                  </td>

                  <td className="px-3 py-2 text-xs text-center">
                    {item.address.pincode}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  className="px-3 py-4 text-center text-sm text-gray-500"
                  colSpan={4}
                >
                  No Service Partners Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ServicePartnerTable;
